import { render, staticRenderFns } from "./ReturnSalesList.vue?vue&type=template&id=67611760&scoped=true"
import script from "./ReturnSalesList.vue?vue&type=script&lang=js"
export * from "./ReturnSalesList.vue?vue&type=script&lang=js"
import style0 from "./ReturnSalesList.vue?vue&type=style&index=0&id=67611760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67611760",
  null
  
)

export default component.exports